import React from "react";

const OptionsBootcamp = () => {
  return (
    <div className="w-full px-6 py-10 bg-white text-black">
      <h2 className="text-center text-2xl md:text-4xl font-bold mb-2">
        INVEST WITH CERTAINTY
      </h2>
      <p className="text-center text-md md:text-lg font-semibold mb-6">
        Get Access To{" "}
        <span className="text-primaryYellow font-bold">
          OPTIONS VIRTUAL BOOTCAMP
        </span>{" "}
        AT <span className="text-primaryYellow font-bold">SGD 388</span> Today!
      </p>

      <div className="bg-black text-yellow-400 py-4 px-6 text-center text-2xl font-bold tracking-wide rounded-t-xl">
        IWC OPTIONS BOOTCAMP
      </div>

      <div className="grid md:grid-cols-4 grid-cols-1 border border-yellow-400">
        {/* Day 1 */}
        <div className="border p-4">
          <div className="bg-yellow-400 text-black text-center font-bold py-2 mb-4">
            DAY 1, FRIDAY
          </div>
          <ol className="list-decimal list-inside space-y-2 font-medium">
            <li>
              <em>Introduction to Options</em>
            </li>
            <li>
              <em>Setting up trading system</em>
            </li>
            <li>
              <em>Live demo trading</em>
            </li>
          </ol>
        </div>

        {/* Day 2 */}
        <div className="border p-4">
          <div className="bg-yellow-400 text-black text-center font-bold py-2 mb-4">
            DAY 2, SATURDAY
          </div>
          <ol className="list-decimal list-inside space-y-2 font-medium">
            <li>
              <em>Strategy 1 - Bearish</em>
            </li>
            <li>
              <em>Strategy 2 - Bullish</em>
            </li>
            <li>
              <em>4 Options Criteria</em>
            </li>
          </ol>
        </div>

        {/* Day 3 */}
        <div className="border p-4">
          <div className="bg-yellow-400 text-black text-center font-bold py-2 mb-4">
            DAY 3, SUNDAY
          </div>
          <ol className="list-decimal list-inside space-y-2 font-medium">
            <li>
              <em>Technical Analysis</em>
            </li>
            <li>
              <em>Traders’ Mindset</em>
            </li>
            <li>
              <em>2E Method</em>
            </li>
            <li>
              <em>Summary</em>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default OptionsBootcamp;
